import React from 'react';
import styled, { css } from 'styled-components';

import languageHelper from '../../../utils/language/language-helper';
import { stepHeaderCounterLabel } from '../../../utils/language/wizard-labels';

import mq from '../../../styles/breakpoints';
import Colors from '../../../styles/colors';
import { ButtonLabel } from '../../../styles/generic';

import { TextDirection } from '../../../tokens';

interface Props {
  currentStep: number;
  maxAmountOfSteps: number;
  showProgressBar?: boolean;
  stepColor?: string;
  textDirection?: 'right' | 'left';
}

const StepCounter = ({
  currentStep,
  maxAmountOfSteps,
  showProgressBar = true,
  stepColor = Colors.abnGreen300,
  textDirection = TextDirection.RIGHT,
}: Props) => {
  const percentage = ((currentStep || 0) / maxAmountOfSteps) * 100;
  const { lang } = languageHelper();

  return (
    <Container data-testid="step-counter">
      <Text
        data-testid="step-copy"
        alignTop={!showProgressBar}
        textColor={stepColor}
        textDirection={textDirection}
        smallerFont={!showProgressBar}
      >
        {stepHeaderCounterLabel(currentStep, maxAmountOfSteps).counter[lang]}
      </Text>
      {showProgressBar && (
        <ProgressContainer>
          <ProgressBar amount={percentage} data-testid="progress-bar" />
        </ProgressContainer>
      )}
    </Container>
  );
};

export default StepCounter;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${mq.from.breakpoint.M`
    gap: 0;
  `}
`;

const Text = styled.span<{
  alignTop: boolean;
  textColor?: string;
  textDirection?: 'right' | 'left';
  smallerFont?: boolean;
}>`
  ${ButtonLabel};
  color: ${({ theme, textColor }) => textColor || theme.colors.abnGreen300};
  font-family: ${({ theme }) => theme.fontRegular};
  text-align: ${({ textDirection }) => textDirection};

  ${({ smallerFont }) =>
    smallerFont
      ? css`
          font-size: 14px;
          line-height: 20px;
        `
      : undefined}

  ${mq.from.breakpoint.M`
    position: relative;
    top: ${({ alignTop }: { alignTop: boolean }) =>
      alignTop ? `0px` : `-22px`};
  `}
`;

const ProgressContainer = styled.div`
  background: ${Colors.white};
  height: 4px;
  width: 100%;
`;

const ProgressBar = styled.div<{ amount: number }>`
  background: ${({ theme }) => theme.colors.abnGreen400};
  height: 4px;
  width: ${({ amount }) => amount}%;
`;
